var play_icon_rtlignore_default = {
  "shadow": "_4vwzu",
  "playIcon": "KtuyQ"
};
export {
  play_icon_rtlignore_default as default
};
//# sourceMappingURL=play-icon.rtlignore-scss.js.map
